/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CouponData } from './CouponData';
import {
    CouponDataFromJSON,
    CouponDataFromJSONTyped,
    CouponDataToJSON,
    CouponDataToJSONTyped,
} from './CouponData';
import type { MoneyOutput } from './MoneyOutput';
import {
    MoneyOutputFromJSON,
    MoneyOutputFromJSONTyped,
    MoneyOutputToJSON,
    MoneyOutputToJSONTyped,
} from './MoneyOutput';
import type { DiscountData } from './DiscountData';
import {
    DiscountDataFromJSON,
    DiscountDataFromJSONTyped,
    DiscountDataToJSON,
    DiscountDataToJSONTyped,
} from './DiscountData';

/**
 * 
 * @export
 * @interface PromotionPerformanceData
 */
export interface PromotionPerformanceData {
    /**
     * 
     * @type {number}
     * @memberof PromotionPerformanceData
     */
    ordersMarketing?: number;
    /**
     * 
     * @type {number}
     * @memberof PromotionPerformanceData
     */
    ordersCompleted?: number;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof PromotionPerformanceData
     */
    turnoverMarketing?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof PromotionPerformanceData
     */
    turnoverCompleted?: MoneyOutput;
    /**
     * 
     * @type {Array<CouponData>}
     * @memberof PromotionPerformanceData
     */
    coupons?: Array<CouponData>;
    /**
     * 
     * @type {Array<DiscountData>}
     * @memberof PromotionPerformanceData
     */
    discounts?: Array<DiscountData>;
}

/**
 * Check if a given object implements the PromotionPerformanceData interface.
 */
export function instanceOfPromotionPerformanceData(value: object): value is PromotionPerformanceData {
    return true;
}

export function PromotionPerformanceDataFromJSON(json: any): PromotionPerformanceData {
    return PromotionPerformanceDataFromJSONTyped(json, false);
}

export function PromotionPerformanceDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PromotionPerformanceData {
    if (json == null) {
        return json;
    }
    return {
        
        'ordersMarketing': json['ordersMarketing'] == null ? undefined : json['ordersMarketing'],
        'ordersCompleted': json['ordersCompleted'] == null ? undefined : json['ordersCompleted'],
        'turnoverMarketing': json['turnoverMarketing'] == null ? undefined : MoneyOutputFromJSON(json['turnoverMarketing']),
        'turnoverCompleted': json['turnoverCompleted'] == null ? undefined : MoneyOutputFromJSON(json['turnoverCompleted']),
        'coupons': json['coupons'] == null ? undefined : ((json['coupons'] as Array<any>).map(CouponDataFromJSON)),
        'discounts': json['discounts'] == null ? undefined : ((json['discounts'] as Array<any>).map(DiscountDataFromJSON)),
    };
}

export function PromotionPerformanceDataToJSON(json: any): PromotionPerformanceData {
    return PromotionPerformanceDataToJSONTyped(json, false);
}

export function PromotionPerformanceDataToJSONTyped(value?: PromotionPerformanceData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ordersMarketing': value['ordersMarketing'],
        'ordersCompleted': value['ordersCompleted'],
        'turnoverMarketing': MoneyOutputToJSON(value['turnoverMarketing']),
        'turnoverCompleted': MoneyOutputToJSON(value['turnoverCompleted']),
        'coupons': value['coupons'] == null ? undefined : ((value['coupons'] as Array<any>).map(CouponDataToJSON)),
        'discounts': value['discounts'] == null ? undefined : ((value['discounts'] as Array<any>).map(DiscountDataToJSON)),
    };
}

